// @flow
import actions from "./actions";
import type {GetState, State} from "../../Store";
import type {Dispatch} from "redux";
import type {MapPOIType} from "./utils";
import {MapPOI} from "./utils";
import CurrentRequestSelectors from "../CurrentRequest/selectors";
import CurrentRideSelectors from "../CurrentRide/selectors";
import AppOperations from "../App/operations";
import AppSelectors from "../App/selectors";
import type {LatLngLiteral} from "../../../Utils/MapUtils";
import CurrentRequestOperations from "../CurrentRequest/operations";
import CurrentProposalSelectors from "../CurrentProposal/selectors";
import TokenDataSelectors from "../TokenData/selectors";
import {LatLngEnum} from "../../../Utils/AppUtils";
import {areTwoLatLngsInSamePolygon} from "../../../Utils/MapUtils";
import ServiceConfigSelectors from "../ServiceConfig/selectors";

const updateMapInServicePolygon = actions.updateMapInServicePolygon;
const mapFinishedLoading = actions.mapFinishedLoading;

const updateMapCenter = (center: window.google.maps.LatLng) => {
    return (dispatch: Dispatch, getState: GetState) => {
        const latlng = {lat: center.lat(), lng: center.lng()};
        dispatch(actions.updateMapCenter(latlng));

        const state = getState();
        const servicePolygons = ServiceConfigSelectors.getServicePolygons(state);
        if (CurrentProposalSelectors.canRequestDest(state)) {
            if (TokenDataSelectors.getDestType(state) === LatLngEnum.FORCE_POLYGON) {
                const dest = CurrentRequestSelectors.getDest(state);
                if (!areTwoLatLngsInSamePolygon(latlng, dest, servicePolygons)) {
                    return;
                }
            }
            return dispatch(CurrentRequestOperations.updateDestLatlng(latlng));
        }
        if (CurrentProposalSelectors.canRequestOrigin(state)) {
            if (TokenDataSelectors.getOriginType(state) === LatLngEnum.FORCE_POLYGON) {
                const origin = CurrentRequestSelectors.getOrigin(state);
                if (!areTwoLatLngsInSamePolygon(latlng, origin, servicePolygons)) {
                    return;
                }
            }
            return dispatch(CurrentRequestOperations.updateOriginLatlng(latlng));
        }

    };
};

const panToLatlng = actions.panToLatlng;

const _getLatLngFromPOI = (POI: MapPOIType, state: State): LatLngLiteral => {
    let {lat, lng} = {
        [MapPOI.ORIGIN]: CurrentRequestSelectors.getOrigin,
        [MapPOI.DEST]: CurrentRequestSelectors.getDest,
        [MapPOI.PICKUP]: CurrentRideSelectors.getPickup,
        [MapPOI.DROPOFF]: CurrentRideSelectors.getDropoff,
        [MapPOI.VAN]: CurrentRideSelectors.getVanLocation,
        [MapPOI.RIDER]: AppSelectors.getRiderLocation,
    }[POI](state);
    return {lat, lng};
};
const focusMapBounds = (POIs: Array<MapPOIType>) => {
    return (dispatch: Dispatch, getState: GetState) => {
        if (POIs.length < 1) {
            return dispatch(AppOperations.noOperation());
        }
        const state = getState();
        return dispatch(actions.focusMapBoundsFromArray(POIs.map(POI => _getLatLngFromPOI(POI, state))));
    };
};

const focusMapBoundsOriginPickup = () => focusMapBounds([MapPOI.ORIGIN, MapPOI.PICKUP]);
const focusMapBoundsRiderPickup = () => focusMapBounds([MapPOI.RIDER, MapPOI.PICKUP]);
const focusMapBoundsOriginDest = () => focusMapBounds([MapPOI.ORIGIN, MapPOI.DEST]);


export default {
    updateMapInServicePolygon,
    mapFinishedLoading,
    updateMapCenter,
    panToLatlng,
    focusMapBounds,
    focusMapBoundsOriginPickup,
    focusMapBoundsRiderPickup,
    focusMapBoundsOriginDest,
};


// WEBPACK FOOTER //
// ./src/Store/Ducks/MapData/operations.js